// ----------------- Imports -----------------
import React from "react";
import { useRouter } from "next/router";
import { useQuery } from "@tanstack/react-query";
import fetchEventOrg from "api/event/fetchEventOrg";
import BrandingLayout from "components/brandingLayout/brandingLayout";
import { useLang } from "hooks/useLang";


// ----------------- Component -----------------
const EventOrganizer = () => {
    const router = useRouter();
    const { multiLangVars } = useLang();
    // Data fetcching
    const orgID = router?.query?.organizerid
    const { data, isLoading } = useQuery({
        queryKey: ["fetchOrg", orgID],
        queryFn: () => fetchEventOrg(orgID as string),
        enabled: !!orgID,
    });

    const payload = data?.payload;
    const orgData = data?.payload?.data


    console.log({orgData})

    // SEO values
    const name =
        orgData?.[multiLangVars("name") as "ar_name" | "en_name"] || "";

    const description =
        orgData?.[multiLangVars("description") as "ar_description" | "en_description"] || "";


    return <BrandingLayout payload={payload} subTitle="organizer" logo={orgData?.logo} poster={payload?.current[0]?.posters[0]} data={orgData} name={name} description={description} isLoading={isLoading} />
};

export default EventOrganizer;
